import { AfterViewInit, Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatTableDataSource } from '@angular/material/table'
import { CargaHoraria } from 'src/app/models/carga-horaria'
import { CargaHorariaCompleto } from 'src/app/models/carga-horaria-completo'

@Component({
  selector: 'app-plano-viewer',
  templateUrl: './plano-viewer.component.html',
  styleUrls: ['./plano-viewer.component.css'],
  standalone: false
})
export class PlanoViewerComponent implements AfterViewInit {
  colunasGrid: string[] = ['idItemPlano', 'descricaoItemPlano', 'cargaHorariaPrevista', 'cargaHorariaEfetiva']
  dataSource: MatTableDataSource<CargaHoraria> = new MatTableDataSource()

  constructor(
    public dialogRef: MatDialogRef<PlanoViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CargaHorariaCompleto
  ) {}

  ngAfterViewInit(): void {
    this.dataSource = new MatTableDataSource(this.data.plano)
  }
}
